<template>
  <b-card
    v-if="tags !== null"
    :title="$t('settings.tags')"
  >
    <b-card-body class="p-0">
      <b-table
        ref="tableTags"
        :items="tags"
        thead-class="d-none"
        responsive
        striped
        bordered
      >
        <template #cell(label)="data">
          <span :class="{ 'row-cisoff': isObsolete(data.item.label) }">{{ data.item.label }}</span>
        </template>

        <template #cell(color)="data">
          <div class="d-flex align-items-center justify-content-end">
            <b-link
              :id="'popover-color-' + data.index"
              class="w-100"
            >
              <b-badge
                class="d-block"
                pill
                :style="{ 'background-color': data.item.color }"
              >
                <feather-icon
                  v-if="isObsolete(data.item.label)"
                  icon="EyeOffIcon"
                  size="16"
                />
              &nbsp;</b-badge>
            </b-link>

            <b-popover
              placement="top"
              :target="'popover-color-' + data.index"
              triggers="click blur"
            >
              <v-swatches
                v-model="data.item.color"
                swatches="text-advanced"
                show-fallback
                inline
              />
            </b-popover>
            <b-link
              :title="$t('common.hide')"
              class="ml-1"
              @click="hide(data.item.label, (isObsolete(data.item.label) ? true : null))"
            >
              <feather-icon
                :icon="isObsolete(data.item.label) ? 'EyeOffIcon' : 'EyeIcon'"
                class="cursor-pointer"
                size="16"
              />
            </b-link>
          </div>

        </template>
      </b-table>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardBody, BTable, BBadge, BPopover, BLink,
} from 'bootstrap-vue'
import VSwatches from 'vue-swatches'
import 'vue-swatches/dist/vue-swatches.css'
import { swalCustomOptions, removeFromArray } from '../layouts/layouts.utils'

export default {
  components: {
    BCard, BCardBody, BTable, BBadge, BPopover, BLink, VSwatches,
  },

  props: {
    tags: {
      type: Array,
      default: null,
    },
    settings: {
      type: Object,
      default: null,
    },
  },
  methods: {
    isObsolete(label) {
      if (this.settings && this.settings.otags) return this.settings.otags.find(o => o === label)
      return false
    },
    hide(label, off) {
      this.$swal(swalCustomOptions('common.hide-warning', 'common.hide-warning2'))
        .then(result => {
          if (result.value === true) {
            this.settings.lastUpdate = new Date()
            if (!this.settings.otags) this.settings.otags = []
            if (off) removeFromArray(this.settings.otags, label)
            else this.settings.otags.push(label)
            this.$refs.tableTags.refresh()
          }
        })
    },
  },
}
</script>
<style lang="scss">
.vue-swatches__fallback__input--wrapper{
  padding-right: 0px;
}
.vue-swatches__fallback__wrapper {
  width: 100%;
}
.vue-swatches__fallback__input{
  text-align: center;
}
</style>
